import React from "react";
import { define } from "remount";
import { IAppMode, IAuthType } from "./bootstrapper";
import { IRouterType } from "./routes/router";

const authType: IAuthType = "Kuika";
const routerType: IRouterType = "HashRouter";
const appMode: IAppMode = "WebComponent";

export default () => {
  const AppBootstrapper = React.lazy(() =>
    import("./bootstrapper").then((module) => ({ default: module.AppBootstrapper }))
  );

  const WebComponent = (props) => {
    const validAttributes = new Set([
      "external_user",
      "external_access_token",
      "external_refresh_token",
      "starting_screen"
    ]);

    const { external_user, external_access_token, external_refresh_token, starting_screen } = props;
    const [screenInputProps, setScreenInputProps] = React.useState({});

    React.useEffect(() => {
      const webComponentElement = document.querySelector("reslen-01-woolknot-boss-screen-rlse");
      if (!webComponentElement) return;

      const extractedScreenInputs = {};
      const detectedInvalidProps = [];

      Array.from(webComponentElement.attributes).forEach((attr) => {
        const name = attr.name;
        const value = attr.value;

        if (name.startsWith("screeninput_")) {
          const camelCaseName = name.replace(/^screeninput_/, "screenInput_");
          extractedScreenInputs[camelCaseName] = value;
        } else if (!validAttributes.has(name) && !name.startsWith("screeninput_")) {
          detectedInvalidProps.push(name);
        }
      });

      setScreenInputProps(extractedScreenInputs);
    }, []);

    return (
      <AppBootstrapper
        authType={authType}
        routerType={routerType}
        tagName="reslen-01-woolknot-boss-screen-rlse"
        external_user={external_user}
        external_access_token={external_access_token}
        external_refresh_token={external_refresh_token}
        startingScreen={starting_screen}
        appMode={appMode}
        {...screenInputProps}
      />
    );
  };
  define(
    {
      "reslen-01-woolknot-boss-screen-rlse": {
        component: WebComponent,
        attributes: ["external_user", "external_access_token", "external_refresh_token", "starting_screen"]
      }
    },
    {
      shadow: false,
      retarget: true,
      quiet: true
    }
  );
};
